import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-userprivilege',
  templateUrl: './userprivilege.component.html',
  styleUrls: ['./userprivilege.component.css']
})
export class UserprivilegeComponent implements OnInit {

  constructor(private userService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  //privilegeUrl='http://192.241.151.66:5000/viewPrivilege'
  //addPrivilegeUrl='http://192.241.151.66:5000/addPrivilege'
  //deletePrivilegeUrl='http://192.241.151.66:5000/viewPrivilege/'
  output:any=[]
  isChange=false  //for alert
  alert=""
  AddPrvShown=false
  PName=""
  deletePrvilegeId=""
  deletePrvilegeName=""
  DeleteAlert=""
  data={
    privilege_name:""
  }
  //--------function for shown the alert----------
  shown(){
    this.isChange=false
  }
  //------function for shown add privileges-------
  AddPrvilege(){
    this.isChange=false
    if(this.AddPrvShown){
      this.AddPrvShown=false
    }
    else{
      this.AddPrvShown=true
    }
    this.data.privilege_name=""
  }
  //-------add button click------------------------
  AddNewPrivilege(){
    if(this.data.privilege_name==""){
      this.PName="give a name for the privilege"
      return
     }
   this.isChange=true
   this.userService.AddPrivilege(this.data).subscribe((res) => { 
      this.alert=res.message;
      console.log("res=",this.alert);
    //---------call api for privilege listing-----
    this.ngOnInit();
    this.data.privilege_name=""
   })
   
  }
  //----function for get id of deleted privileges---
  SetPrivilegeId(value:any,value1:any){
    console.log("id=",value)
    this.deletePrvilegeId=value
    this.deletePrvilegeName=value1
  }
//--------function for delete privilege------
DeletePrivilege(){
  console.log("id=",this.deletePrvilegeId)
   //-------api delete user-------------
   this.userService.DeletePrivilege(this.deletePrvilegeId).subscribe((res)=>{
    this.DeleteAlert=res.message
    console.log("alert=",this.DeleteAlert)
     //---------call api for privilege listing-----
     this.ngOnInit();
   })
}
  //---------check value changes in the text box----
valuechange1(newValue1: any) {
  this.data.privilege_name=newValue1
  this.PName=""
}
  ngOnInit(): void {

    this.userService.ViewPrivileges().subscribe((res)=>{
      this.output=res.data
  console.log("On init")
    })
  }

}
